import React from "react";
import {IProduct} from 'data/interfaces/products';
import {IAdStructure} from '../commons/adStructure/AdStructure';
import {IUser} from 'data/redux/reducers/authenticationReducer';
import {ITransaction} from 'data/interfaces/transactions';
import {IOrder, IOrderOptions} from 'data/interfaces/orders';
import FirstStage from './components/firstStage/FirstStage';
import PreparedAdStructure from 'gui/pages/mainRouter/pages/ad/components/commons/preparedAdStructure';
import SaleDetails from './components/saleDetails';
import TopDetails
  from 'gui/pages/mainRouter/pages/ad/components/commons/preparedAdStructure/components/purchaseForm/components/topDetails';
import {flightCompanyToLogoUrl} from 'gui/components/listPage/components/ad/components/airlineImageSquare';
import {AdFlightCardDetails} from 'gui/components/listPage/components/ad/components/adFlight';

export interface IAdFlight extends IAdStructure {
  order: IOrder;
  transaction?: ITransaction;
  user: IUser;
  signedIn?: boolean;
  beginOrder?: (product: IProduct, options: IOrderOptions) => Promise<void>;
}

export const generateFlightTitle = props => ['טיסה', `${props.product.ticketDetails.originAirport.city} - ${props.product.ticketDetails.destinationAirport.city}`].join(" ");

export const AdFlightTopDetails = props => <TopDetails title={generateFlightTitle(props)}
                                                       logoSrc={flightCompanyToLogoUrl(props.product.ticketDetails.originFlightCompany)}>
  <AdFlightCardDetails product={props.product}/>
</TopDetails>;

const AdFlight = (props: IAdFlight) => {
  return (<PreparedAdStructure
    {...props}
    firstStageComponent={FirstStage}
    title={generateFlightTitle(props)}
    originalPrice={props.product.ticketDetails.currentAirlineAllTicketsPrice}
    saleDetails={<SaleDetails product={props.product} order={props.order}/>}
    purchaseDetailsFields={<>

    </>}
    purchaseDetailsFormInitialValue={{
      ticketsAmount: props.product.ticketDetails.ticketsAmount
    }}

    aboveConclusionCardComponent={
      <AdFlightTopDetails {...props}/>
    }

  />);
};

AdFlight.defaultProps = {
  product: {},
  order: {},
  user: {},
  isProductOwner: false,
  isOrderOwner: false,
};

export default AdFlight;
